import React, { useState } from "react";
import { useLeaveData } from "../../../hooks/leaveData";

const Years = () => {
    const { setLeaveData } = useLeaveData();

    const [selectedYear, setSelectedYear] = useState(null);

    const currentYear = new Date().getFullYear();

    const years = [];
    for (let year = currentYear; year >= 2024; year--) {
        years.push(year);
    }

    const handleSetSelectedYear = (year) => {
        setSelectedYear(year);
        setLeaveData('year', year);
        setLeaveData('employee', null);
    }

    return (
        <div className="years">
            <div className="panel">
                <div className="panel-title">
                    <h3>Years</h3>
                </div>
                <div className="panel-content">
                    <ul>
                        {
                            years?.map((year) => (
                                <li key={year} className={selectedYear === year ? 'active' : ''} onClick={() => handleSetSelectedYear(year)}>{year}</li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Years;